// Runtime-configured build (used by `npm run build-runtime`).
//
// Unlike the brand variants (urosante/uroservice), this build does NOT bake the
// API hostname in at build time. It reads it at runtime from window.__AMBULIO__,
// which each deployment provides by serving a small /config.js before the app
// bundle (see index.html). One built artifact can therefore serve any backend or
// brand: the production sites, for example, differ only by the /config.js their
// web server returns — no separate build per brand.
var runtime = (typeof window !== 'undefined' && window.__AMBULIO__) || null

if (!runtime || !runtime.hostname) {
  throw new Error(
    'Ambulio: runtime config missing. /config.js must define ' +
    'window.__AMBULIO__ = { hostname, fakturoid } and load before the app bundle.'
  )
}

module.exports = { hostname: runtime.hostname, fakturoid: runtime.fakturoid === true }



// WEBPACK FOOTER //
// ./src/variables.js